import { render, staticRenderFns } from "./ModalDispatcher.vue?vue&type=template&id=52bf210a"
import script from "./ModalDispatcher.vue?vue&type=script&lang=js"
export * from "./ModalDispatcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports